import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FaPlus } from "react-icons/fa6";
import ModalProps from "@ltypes/modalProps";
import Modal from "@components/modals/Modal/Modal";
import TextField from "@components/forms/TextField/TextField";
import { ListItemType } from "@components/forms/List/List";
import './AddItemListModal.scss';

type AddItemListModalProps = {
    items: Array<ListItemType>,
    iconPath: string,
    onCreate: (item: ListItemType) => void,
} & ModalProps;

function AddItemListModal(props: AddItemListModalProps) {
    const [search, setSearch] = useState<string>('');

    const { t } = useTranslation();

    const handleClick = (item: ListItemType) => {
        props.onCreate(item);
        props.onHide();
    };

    useEffect(() => {
        setSearch('');
    }, [props.visible]);
    
    return (
        <Modal className="modal-additemlist" visible={props.visible} onHide={props.onHide}>
            <div className="row g-3">
                <div className="col-12">
                    <TextField value={search} onChange={setSearch} placeholder={`${t('text.search')} ...`}/>
                </div>

                <div className="col-12">
                    <div className="list">
                        {props.items.filter((i: ListItemType) => search.trim() === '' || i.label.toLowerCase().includes(search.toLowerCase()) || i.value.toLowerCase().includes(search.toLowerCase()) || i.description.toLowerCase().includes(search.toLowerCase())).slice(0, 1000).map((item: ListItemType, index: number) => (
                            <div key={index}className="item" onClick={() => handleClick(item)}>
                                <img className="item-icon" src={`${props.iconPath}${item.value.toLocaleLowerCase()}.png`} loading="lazy"/>
                                <span className="item-value">{item.label}</span>
                                <span className="item-description">{item.description}</span>
                                <span className="item-actions"><FaPlus/></span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </Modal>
    );
}

export default AddItemListModal;
